import { render, staticRenderFns } from "./screening-content.vue?vue&type=template&id=78aad911&scoped=true"
import script from "./screening-content.vue?vue&type=script&lang=js"
export * from "./screening-content.vue?vue&type=script&lang=js"
import style0 from "./screening-content.vue?vue&type=style&index=0&id=78aad911&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78aad911",
  null
  
)

export default component.exports